


























import { getFederationComponent } from '@src/federations/getFederationComponent';
import { SdsGlobalHeaderIconMobile } from '@superbet-group/web.lib.ui-components';
import {
    isMobileLayout,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import { isSocialEnabled } from '@socialFederation/helpers';

export default defineComponent({
    name: 'AccountUserInfoAvatar',
    props: {
        hasNotification: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        avatarSizeOverride: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const authModule = useVuexStore<AuthenticationStore>('data/authentication');

        const user = authModule.getter('user');

        const userAvatarSize = computed(() => isMobileLayout() ? 'sm' : 'md');

        return {
            userAvatarSize: props.avatarSizeOverride || userAvatarSize.value,
            user,
            isSocialEnabled: isSocialEnabled(),
        };
    },
    components: {
        SuperSocialUserAvatar: getFederationComponent(() => import('social/UserAvatar')),
        UseSocialUser: getFederationComponent(() => import('social/UseSocialUser')),
        SdsGlobalHeaderIconMobile,
    },
});
